// extracted by mini-css-extract-plugin
module.exports = {"root":"columnGroup_root__tOfb_"};